import {computed, Signal, signal, WritableSignal, Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class InscriptionService {

  public youngEmail: WritableSignal<string> = signal("");
  public resp1Email: WritableSignal<string> = signal("");
  public resp2Email: WritableSignal<string> = signal("");

  public alreadyExistsYoungEmail: WritableSignal<boolean> = signal(false);
  public alreadyExistsResp1Email: WritableSignal<boolean> = signal(false);
  public alreadyExistsResp2Email: WritableSignal<boolean> = signal(false);

  public hasSameEmail: Signal<boolean> = computed(() => {
    return (this.youngEmail().length>0 && this.resp1Email().length>0 && this.youngEmail() === this.resp1Email())
      || (this.youngEmail().length>0 && this.resp2Email().length>0 && this.youngEmail() === this.resp2Email())
      || (this.resp1Email().length>0 && this.resp2Email().length>0 && this.resp1Email() === this.resp2Email());
  });

  public alreadyExistsEmail: Signal<boolean> = computed(() => {
    return this.alreadyExistsYoungEmail() || this.alreadyExistsResp1Email() || this.alreadyExistsResp2Email();
  });

  public alreadyExistsPhone: Signal<boolean> = computed(() => {
    return this.alreadyExistsYoungPhone() || this.alreadyExistsResp1Phone() || this.alreadyExistsResp2Phone();
  });

  public youngPhone: WritableSignal<string> = signal("");
  public resp1Phone: WritableSignal<string> = signal("");
  public resp2Phone: WritableSignal<string> = signal("");

  public alreadyExistsYoungPhone: WritableSignal<boolean> = signal(false);
  public alreadyExistsResp1Phone: WritableSignal<boolean> = signal(false);
  public alreadyExistsResp2Phone: WritableSignal<boolean> = signal(false);

  public hasSamePhone: Signal<boolean> = computed(() => {
    return (this.youngPhone().length>0 && this.resp1Phone().length>0 && this.youngPhone() === this.resp1Phone())
      || (this.youngPhone().length>0 && this.resp2Phone().length>0 && this.youngPhone() === this.resp2Phone())
      || (this.resp1Phone().length>0 && this.resp2Phone().length>0 && this.resp1Phone() === this.resp2Phone());
  });

  public setYoungEmail(email: string) {
    this.youngEmail.set(email.trim().toLowerCase());
  }

  public setResp1Email(email: string) {
    this.resp1Email.set(email.trim().toLowerCase());
  }

  public setResp2Email(email: string) {
    this.resp2Email.set(email.trim().toLowerCase());
  }

  public setYoungPhone(phone: string) {
    this.youngPhone.set(phone.trim().toLowerCase());
  }

  public setResp1Phone(phone: string) {
    this.resp1Phone.set(phone.trim().toLowerCase());
  }

  public setResp2Phone(phone: string) {
    this.resp2Phone.set(phone.trim().toLowerCase());
  }

  public setAlreadyExistsYoungEmail(alreadyExists: boolean) {
    this.alreadyExistsYoungEmail.set(alreadyExists);
  }

  public setAlreadyExistsResp1Email(alreadyExists: boolean) {
    this.alreadyExistsResp1Email.set(alreadyExists);
  }

  public setAlreadyExistsResp2Email(alreadyExists: boolean) {
    this.alreadyExistsResp2Email.set(alreadyExists);
  }

  public setAlreadyExistsYoungPhone(alreadyExists: boolean) {
    this.alreadyExistsYoungPhone.set(alreadyExists);
  }

  public setAlreadyExistsResp1Phone(alreadyExists: boolean) {
    this.alreadyExistsResp1Phone.set(alreadyExists);
  }

  public setAlreadyExistsResp2Phone(alreadyExists: boolean) {
    this.alreadyExistsResp2Phone.set(alreadyExists);
  }

  public resetYoungPhone() {
    this.setYoungPhone("");
    this.setAlreadyExistsYoungPhone(false);
  }

  public resetYoungEmail() {
    this.setYoungEmail("");
    this.setAlreadyExistsYoungEmail(false);
  }

  public resetRespPhone(isFirstResponsable: boolean = true) {
    if (isFirstResponsable) {
      this.setResp1Phone("");
      this.setAlreadyExistsResp1Phone(false);
    } else {
      this.setResp2Phone("");
      this.setAlreadyExistsResp2Phone(false);
    }
  }

  public resetRespEmail(isFirstResponsable: boolean = true) {
    if (isFirstResponsable) {
      this.setResp1Email("");
      this.setAlreadyExistsResp1Email(false);
    } else {
      this.setResp2Email("");
      this.setAlreadyExistsResp2Email(false);
    }
  }
}
